import React, {useMemo, useState} from 'react'
import { ITransportAreaItem } from '../../../../../../modules/API/Defaults/models/transportAreas'
import SearchFromTheList from '../../../../../../generic/customSearchComponents/SearchFromTheList'

type Props = {
    defaultID: number
    setTransportAreaID: React.Dispatch<React.SetStateAction<number>>
    list: ITransportAreaItem[]
    placeholder?: string
    required?: boolean
}

const SearchTransportAreas = ({
    defaultID, setTransportAreaID, list, placeholder, required
}: Props) => {
    const defaultTransportArea = list.filter(item => item.AreaID === defaultID)[0]
    const [isOpenDropDown, setIsOpenDropDown] = useState<boolean>(false)
    const [search, setSearch] = useState<string>(() => defaultTransportArea?.AreaDesc.trim() || '')

    const handleSearch = (e: string) => {
        if(e === '') {
            setIsOpenDropDown(false)
            setSearch('')
            setTransportAreaID(0)
            return
        }
        setIsOpenDropDown(true)
        setSearch(e)
    }
    const handleSelect = (item: ITransportAreaItem) => {
        setSearch(item.AreaDesc.trim())
        setIsOpenDropDown(false)
        setTransportAreaID(item.AreaID)
    }
    const render = useMemo(() => {
        if(!list) return []
        return list.filter(item => 
            item.AreaDesc.trim().toLocaleLowerCase().includes(search.toLocaleLowerCase())
        )
    }, [search, list])
    return (
        <SearchFromTheList
            isOpenList={isOpenDropDown}
            placeHolder={placeholder || 'חפש קו הפצה'}
            list={render}
            selectFunc={handleSelect}
            searchFunc={handleSearch}
            isNeedFullObject
            input={search}
            itemDisplayName='AreaDesc'
            nameIdElement='AreaID'
            required={required}
            size={'full'}
        />
    )

}

export default SearchTransportAreas